module.exports = "/_next/static/images/og-image-diputi-min-5f7ee61732884e16d3477b0aff6ce1b2.jpg.webp";